export enum WithdrawDialogState {
  Creation = 'creation',
  Confirmation = 'confirmation',
}
